import TiktokAppDrawer from './TiktokAppDrawer';

const drawers = [TiktokAppDrawer];

export default drawers;
